import React, { forwardRef, ReactNode } from 'react'
import {
  Checkbox,
  CheckboxProps,
  FormControlLabel,
  Typography,
} from '@mui/material'

import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import { PORTAL_TEXT } from '@/apps/latest/shared/styles/portalTypography'

// Notion 流 checkbox + label 統合 primitive.
// label は PORTAL_TEXT.caption (= 12/secondary). checkbox 18px.
// row として並べる場合は caller 側で Stack direction="row" gap=2 等.

interface NotionCheckboxProps extends Omit<CheckboxProps, 'color'> {
  /** 省略時は checkbox 単体 (= テーブル行内の選択チェック等)。 */
  label?: ReactNode
}

const CHECKBOX_SX = {
  color: colorTokens.border.default,
  p: 0.5,
  '&.Mui-checked': {
    color: colorTokens.accent.primary,
  },
  '&.Mui-disabled': {
    color: colorTokens.border.faint,
  },
  '& .MuiSvgIcon-root': { fontSize: 18 },
}

export const NotionCheckbox = forwardRef<
  HTMLButtonElement,
  NotionCheckboxProps
>(({ label, disabled, ...rest }, ref) => {
  if (!label) {
    return <Checkbox ref={ref} disabled={disabled} sx={CHECKBOX_SX} {...rest} />
  }
  return (
    <FormControlLabel
      control={
        <Checkbox
          ref={ref}
          disabled={disabled}
          sx={{ ...CHECKBOX_SX, mr: 0.5 }}
          {...rest}
        />
      }
      label={
        <Typography component="span" sx={PORTAL_TEXT.caption}>
          {label}
        </Typography>
      }
      disabled={disabled}
      sx={{
        m: 0,
        gap: 0.5,
        '& .MuiFormControlLabel-label.Mui-disabled': {
          color: colorTokens.fg.disabled,
        },
      }}
    />
  )
})
NotionCheckbox.displayName = 'NotionCheckbox'
